import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { getQueryParamsFromSearchString } from '~/shared/helpers/getQueryParamsFromSearchString'
import { useBulkSelector } from '~/shared/hooks/useBulkSelector'
import {
  selectCohortID,
  selectGiaApiKeys,
  selectLanguage,
} from '~/shared/store/common/selects'
import { setUpUUIDAction } from '~/shared/store/user/actions'

const useSelectors = () =>
  useBulkSelector({
    cohort: selectCohortID,
    giaApiKeys: selectGiaApiKeys,
    lng: selectLanguage,
  })

export const useSetUuid = () => {
  const dispatch = useDispatch()
  const { cohort, lng, giaApiKeys } = useSelectors()

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search)
    const uuidFromUrl = searchParams.get('uuid')
    const utmTags = getQueryParamsFromSearchString(document.location.search)

    if (cohort && giaApiKeys && lng) {
      dispatch(
        setUpUUIDAction({
          cohort,
          giaApiKey: giaApiKeys[lng],
          uuid: uuidFromUrl,
          utmTags,
        }),
      )
    }
  }, [cohort, dispatch, giaApiKeys, lng])
}
